import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {NzModalService, TransferItem} from 'ng-zorro-antd';
import {Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';

@Component({
  selector: 'delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss']
})
export class DeletePopupComponent implements OnInit {
  isVisible = false;
  index = 1;
  name: any;
  title: any;
  data: any;
  id: any;
  isLoadingBtn = false;

  // tslint:disable-next-line:variable-name
  @Output() emitData = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private notification: NzNotificationService
  ) {
  }

  ngOnInit() {

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
  }


  handleCancel(): void {
    this.isVisible = false;
  }

  showModal(data: any, id?: any, dataValue?, name?) {
    this.isVisible = true;
    this.data = data;
    if (typeof id === 'string') {
      const a = [];
      a.push(id);
      this.id = a;
    } else {
      this.id = id;
    }
    const url = window.location.href;
    console.log('dataValue',dataValue)
    if (dataValue && !Array.isArray(dataValue)) {

      if(url.includes('/business/shops')) {
        const value = {
          shopName: dataValue.shopName,
          phoneNumber: dataValue.phoneNumber,
          productId: dataValue.id,
          barcode: dataValue.barcode
        };

        return;
      }
      if(url.includes('business/media')) {

        return;
      }

      if (url.includes('products')) {
        const value = {
          productName: dataValue.productName, infoStatus: dataValue.infoStatus,
          status: dataValue.status, managementStatus: dataValue.managementStatus, barcode: dataValue.barcode
        };

        return;
      }
      if (url.includes('glns')) {
        const value = {
          glnCode : dataValue.glnCode,
          name: dataValue.name,
          status: dataValue.status
        };

        return;
      }
      if (url.includes('distributors')) {
        const value = {
          tax_code : dataValue.tax_code,
          name: dataValue.name,
        };

        return;
      }
      if (url.includes('shops/detail')) {

        if (name === 'unverify') {

          return;
        }
        if (name === 'unblock') {

          return;
        }
        if(name === 'delete') {

          return;
        }

      }

    }

    if (dataValue && Array.isArray(dataValue)) {
      if (url.includes('products')) {

      }
      if (url.includes('glns')) {

      }
      if (url.includes('distributors')) {

      }
      if (url.includes('media')) {

      }
      if(url.includes('/business/shops/detail')) {

        return;
      }
      if (url.includes('/business/shops')) {

        return;
      }

    }
  }

  onSubmit() {
    this.isLoadingBtn = true;

    this.emitData.emit(this.id);
  }

  success() {
    this.isLoadingBtn = false;
  }

}
